import React from 'react'
import Skeleton from '@ynap/skeleton'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('CreditsSkeleton')

function CreditsSkeleton() {
    return (
        <div className={bem()}>
            <Skeleton align="center" className={bem('line')} />
            <Skeleton align="center" className={bem('line')} />
            <Skeleton align="center" className={bem('line')} />
        </div>
    )
}

export default CreditsSkeleton
